export default {
  name: 'ExportTkdListFileModal',
  props: {
    exportSetting: {}
  },
}